import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconOculus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconOculus"><Path fillRule="evenodd" clipRule="evenodd" d="M7.43415 5C5.11354 5 3.12256 6.31041 2.12236 8.20799L1.50015 7.58579L0.0859375 9L1.45847 10.3725C1.22051 12.1804 1.53328 14.1719 2.41247 15.7897C3.39731 17.6018 5.13815 19 7.60082 19H16.3995C18.8622 19 20.603 17.6018 21.5878 15.7897C22.467 14.1719 22.7798 12.1804 22.5418 10.3725L23.9144 9L22.5002 7.58579L21.8779 8.20799C20.8777 6.31041 18.8868 5 16.5662 5H7.43415ZM10 8V10H14V8H10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconOculus;
